// --------------------------------------------------------------------------
// Lottery - Select number of plays for the lottery
// --------------------------------------------------------------------------
// Author:      RSPB
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var ref = { $root: options.context, $document: jQuery(document) };
    var state = {
        amount: 0,
        plays: 1
    };
    var props = {};

    function render() {
        ref.$playBoxes.each(function (index, $element) {
            jQuery($element).toggleClass('lottery__plays__box--active', jQuery($element).data('plays') == state.plays);
        });
        ref.$amountValue.html(state.amount);

        ref.$amountText.toggleClass('lottery__amount--active', state.plays > 0);
        ref.$amountConfirmation.toggleClass('lottery-amount-confirmation__copy--active', state.amount > 0);
    }

    function init() {
        // Cache DOM elements
        ref.$form = ref.$root.closest('form');
        ref.$playBoxes = ref.$root.find('[data-name="plays-box"]');
        ref.$amountText = ref.$root.find('[data-name="lottery-amount-text"]');
        ref.$amountConfirmation = ref.$form.find('[data-name="lottery-amount-confirmation-copy"]');
        ref.$donationConfirmation = ref.$form.find('.donation-amount-confirmation');
        ref.$amountValue = ref.$root.find('[data-name="lottery-amount"]');
        ref.$donationAmountInput = ref.$root.find('input[name="DonationOptions.DonationAmount"]');
        ref.$lotteryPlaysInput = ref.$root.find('input[name="DonationOptions.LotteryPlays"]');
        ref.$paymentDetails = ref.$form.find('.payment-details');

        ref.$donationConfirmation.hide();
        ref.$paymentDetails.addClass('payment-details--top-padding');

        // Set state
        function initialState() {
            var $activePlayBox = ref.$root.find('[data-name="plays-box"]').filter('.lottery__plays__box--active');

            return {
                amount: $activePlayBox.data('amount'),
                plays: $activePlayBox.data('plays')
            };
        }

        state = initialState();

        ref.$root.on('click', '[data-name="plays-box"]', function (event) {
            var $playBox = jQuery(event.target);

            event.preventDefault();

            // get the new number of plays
            state.plays = $playBox.data('plays');
            state.amount = $playBox.data('amount');

            ref.$document.trigger('donation-amount-confirmation:updateMonthlyAmount', [state.amount]);

            // update form's input elements
            ref.$donationAmountInput.val(state.amount);
            ref.$lotteryPlaysInput.val(state.plays);

            // trigger validation for number of plays element if validation has already taken place,
            // we don't want to trigger validation of the whole form on the first selection
            // of the number of plays
            if (ref.$form.find('.validation-summary-errors').length > 0) {
                ref.$form.validate().form();
            }

            // Trigger render
            render();
        });

        // Render component
        render();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/lottery.js
// module id = 481
// module chunks = 0